export const environment = {
  production: false,
  //apiUrl: 'http://localhost:8081',
  apiUrl: 'https://api.sentechno-dev.com',
  pathApiAdmin: 'api/production/endpoint/administration/v1',
  pathApiProduction: 'api/production/endpoint/produit/v1',
  environmentName: 'DEV'
};
